import {styled, Tag} from "@reside/ui";

/** Preflight "New" chip. */
export const SmallTag = styled(Tag)`
  padding: 4px 8px;
  line-height: 1;
`;
